import { render, staticRenderFns } from "./KodateContentsNew.vue?vue&type=template&id=d67977e0&scoped=true&"
import script from "./KodateContentsNew.vue?vue&type=script&lang=js&"
export * from "./KodateContentsNew.vue?vue&type=script&lang=js&"
import style0 from "./KodateContentsNew.vue?vue&type=style&index=0&id=d67977e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d67977e0",
  null
  
)

export default component.exports